import { useFavorites } from '@/hooks/useFavorites';
import styles from './FavToggle.module.css';

interface FavToggleProps {
  slug: string;
  actId: string;
}

export function FavToggle({ slug, actId }: FavToggleProps) {
  const { favoritesSet, toggle, isToggling } = useFavorites(slug);
  const isFav = favoritesSet.has(actId);
  const label = isFav ? 'Aus Favoriten entfernen' : 'Zu Favoriten hinzufügen';

  return (
    <button
      type="button"
      className={`${styles.toggle} ${isFav ? styles.on : ''}`}
      onClick={() => toggle(actId, !isFav)}
      disabled={isToggling}
      aria-pressed={isFav}
      aria-label={label}
      title={label}
    >
      {isFav ? '★' : '☆'}
    </button>
  );
}
